"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _ThemeProvider = require("../../../components/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var ErrorBox = function ErrorBox(_ref) {
  var children = _ref.children,
      className = _ref.className,
      closeButtonDataTestId = _ref.closeButtonDataTestId,
      onClose = _ref.onClose;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.ErrorBox, className)
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: classes.CloseButton,
    "data-test-id": closeButtonDataTestId,
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "large",
    glyph: "cross"
  })), children);
};

exports["default"] = ErrorBox;
//# sourceMappingURL=index.js.map